// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"15826dc2","626":"7e46cc9b","823":"9e4e9099"}[chunkId] + ".chunk.js";
};